@if (allowCreateAssignment) {
  <button class="jit-new-assignment-button jit-def-button" (click)="onNewAssignment()">
    <jit-report-icons name="doc-2" [bg]="iconBg" [height]="26" [width]="22"></jit-report-icons>
    New Assignment
  </button>
}